export default {
  home: {
    sectionOne: {
      badge: 'Red Latinoamericana de Mitocrítica',
      title:
        'Nuestra red es internacional y reúne a investigadores de diversos países en torno al estudio de la mitocrítica y sus relaciones con la cultura',
      description:
        'Organizamos seminarios mensuales, coloquios y congresos internacionales, y promovemos intercambios, colaboraciones y asociaciones entre instituciones educativas y de investigación, grupos de investigación, investigadores y estudiantes'
    },
    sectionTwo: {
      badge: 'Quiénes somos',
      title: 'Bienvenido a la Red Pachamama',
      description:
        'La Red Latinoamericana de Mitocrítica Pachamama es una red de investigadores que comparten el interés en el estudio de los mitos y sus relaciones con las dinámicas culturales latinoamericanas. Tiene su sede en la Universidad de Puerto Rico en Bayamón y está en funcionamiento desde febrero de 2023 ',
      cards: {
        seminary: {
          title: 'Seminarios',
          summary: 'Seminarios mensuales en línea exclusivos para miembros de la Red Pachamama'
        },
        colloquia: {
          title: 'Coloquios',
          summary: 'Coloquios internacionales organizados por la Red Pachamama'
        },
        community: {
          title: 'Comunidad',
          summary: 'Comunidad integrada con el objetivo de compartir trabajos y conocimientos'
        },
        partnership: {
          title: 'Parcerias',
          summary: 'Parcerías con redes de otros países para una mayor difusión y más conexiones '
        }
      }
    },
    sectionThree: {
      badge: 'Los investigadores',
      title: 'Conozca a nuestros integrantes',
      associate: {
        female: 'Asociada',
        male: 'Asociado'
      },
      president: {
        male: 'Presidente'
      },
      founder: {
        female: 'Fundador',
        male: 'Fundadora'
      },
      secretary: {
        female: 'Secretaria',
        male: 'Secretario'
      },
      moreAboutUs: 'Saiba mais sobre nosotros'
    },
    sectionFour: {
      badge: 'Parcerias',
      title: `Conozca a nuestros <br /> socios`,
      description:
        'La Red Pachamama nace con la intención de fomentar intercambios, encuentros, diálogos y asociaciones. Algunas instituciones ya apoyan a la red y ¡esperamos que se sumen más!',
      asteria:
        'Asociación Internacional de Mitocrítica con sede en la Universidad Complutense de Madrid',
      portoRico:
        'La institución sede de la Red Pachamama, del VIII Congreso Internacional de Mitocrítica y del I Coloquio de Mitocrítica Latinoamericana de la Red Pachamama es la Universidad de Porto Rico en Bayamón',
      ucb: 'El Máster Profesional en Innovación en Comunicación y Economía Creativa colabora con la Red Pachamama, especialmente a través del grupo de investigación Travessias - Transdisciplinaridad y Creatividad, dedicado a los estudios del imaginario, los mitos y la imaginación'
    },
    sectionFive: {
      title: 'Perguntas frequentes',
      description: `Encontre respuestas rápidas y claras sobre quiénes somos y qué hacemos. Si su pregunta no está aquí, <Link href="{{link}}">contáctenos</Link>`,
      faqsLink: {
        answer:
          'Para asociarse, simplemente haga <Link to="{{}}" >clic aquí</Link>, complete el formulario, adjunte una foto y espere la respuesta de la dirección. Si su solicitud es aprobada, recibirá las instrucciones sobre cómo realizar el pago de la cuota anual.'
      },
      faqs: [
        {
          question: '¿Quién puede formar parte de la red Pachamama?',
          answer:
            'Cualquier persona interesada en la mitocrítica latinoamericana, ya sea estudiante de grado o posgrado, investigador, profesor, artista o profesional independiente.'
        },
        {
          question: '¿Cómo puedo asociarme?'
        },
        {
          question: '¿Cómo estaré informado de las actividades de la red?',
          answer:
            'Al completar el formulario, se solicita la indicación de un correo electrónico donde le gustaría recibir la información y un número de teléfono con WhatsApp opcional si desea formar parte del grupo.'
        },
        {
          question: '¿Qué beneficios tendré al asociarme?',
          answer:
            'No. Toda persona interesada en la mitocrítica latinoamericana puede formar parte, independientemente de su nacionalidad o vínculo con una institución latinoamericana.'
        },
        {
          question: '¿Hay restricciones de nacionalidad para los miembros?',
          answer:
            'Não. Toda pessoa interessada na mitocrítica latino-americana pode fazer parte, independente de sua nacionalidade ou vínculo com uma instituição latino-americana.'
        },
        {
          question: '¿Puedo solicitar exención del pago de la cuota anual?',
          answer:
            'Sí. Para hacerlo, deberá enviar una solicitud justificada al correo electrónico redlat.mitocritica@upr.edu. La solicitud será analizada por los miembros de la junta directiva y podría o no ser atendida.'
        },
        {
          question: '¿Cuáles son las obligaciones del asociado?',
          answer:
            'Solo el pago de la cuota anual es obligatorio. Todas las demás actividades son opcionales.'
        }
      ]
    }
  },
  members: {
    institution: 'Instituición',
    interest: 'Áreas de interés',
    usefulLinks: 'Enlaces útiles',
    associate: {
      female: 'Asociada',
      male: 'Asociado'
    },
    president: {
      male: 'Presidente'
    },
    founder: {
      female: 'Fundadora',
      male: 'Fundador'
    },
    secretary: {
      female: 'Secretaria',
      male: 'Secretario'
    },
    sectionOne: {
      title: 'Presidencia',
      presidents: {
        florence: {
          institution:
            'Programa de Posgrado en Innovación en Comunicación y Economía Creativa. Universidad Católica de Brasilia, Brasil.',
          interest:
            'Estudios del mito; Estudios del imaginario; Poesía e imaginación; Inmersión; Narrativa; Mitos femeninos; Mitología indígena; Mitología afrobrasileña.'
        },
        gabriel: {
          institution:
            'Mestrado em Educação e DDHH pela Universidad Autonoma Latinoamericana, Medellin Colombia.',
          interest: 'Arte, Memória Histórica, Mito e Símbolo.'
        }
      }
    },
    sectionTwo: {
      title: 'Fundadores',
      founders: {
        aleida: {
          institution: 'Universidad de Puerto Rico en Bayamón, Departamento de Humanidades.',
          interest:
            'Mitocrítica; Hermenéutica; Fenomenología; Existencialismo; Filosofía del paisaje; Ética ambiental.'
        },
        cristina: {
          institution: 'Investigadora independiente',
          interest:
            'Literaturas de irrealidad iberoamericanas; Discurso fantástico contemporáneo; Literatura fantástica; Narrativa apocalíptica; Mitocrítica.'
        },
        luisAlberto: {
          institution:
            'Departamento de Artes y Humanidades del Centro Universitario del Sur de la Universidad de Guadalajara (México).',
          interest:
            'Mitocrítica; Mitocrítica latinoamericana; Mitocrítica cultural; Teoría del imaginario; Imaginario y representaciones artísticas.'
        },
        luisOwen: {
          institution: 'Universidad de Puerto Rico en Bayamón, Departamento de Humanidades.',
          interest:
            'Filosofía bergsoniana de la religión (el mito según Bergson); Dios como problema filosófico; Antropología filosófica.'
        },
        luisPablon: {
          institution: 'Universidad de Puerto Rico en Bayamón - Departamento de Humanidades',
          interest: 'Mitología, Historia y Filosofía'
        },
        duda: {
          institution: 'Centro de Estudios Humanísticos, Universidad del Minho, Braga, Portugal.',
          interest: 'Mitologías; Cosmogonías; Mitocrítica.'
        },
        miriam: {
          institution: 'Universidad de Sorocaba; Programa de Posgrado en Comunicación y Cultura.',
          interest: 'Narrativas; Expresiones culturales del mito.'
        }
      }
    },
    sectionThree: {
      title: 'Asociados',
      associates: {
        andriolli: {
          institution:
            'Universidad Estatal de Río de Janeiro - UERJ / Brasil - Facultad de Comunicación Social.',
          interest: 'Mito, Imaginario, Oralidad, Folclore.'
        },
        vanessa: {
          institution: 'Instituto Politécnico Nacional (IPN) - México.',
          interest: 'Escatología; Mitos mexicanos; Animalidad'
        },
        navi: {
          institution:
            'Fundación Ética Visionaria. Consejo de Educación. Coordinadora para América Central.',
          interest:
            'Estética Relacional, Etnoficción, Cinematografía, Performance, Ficción Científica.'
        },
        mabel: {
          institution:
            'Universidad de la Frontera, Departamento de Lenguas, Literatura y Comunicación. Temuco, Chile.',
          interest:
            'Pensamiento mítico en la literatura y arte indoamericana y literatura y arte mapuche.'
        },
        gustavo: {
          institution: 'Universidad de Brasilia, PPGCOM/FAC.',
          interest:
            'Poesía, Literatura, Personaje, Mito, Sagrado, Dioses, Medios de comunicación, Religiosidad popular, Imaginario, Biografía.'
        },
        jose: {
          institution:
            'Universidad Nacional Autónoma de México, Facultad de Filosofía y Letras, Colegio de Letras Hispánicas.',
          interest: 'Lengua y Literaturas Hispánicas; Mito; Metaforología; Ficción; Imaginación.'
        },
        hertz: {
          institution:
            'Universidad Federal de Paraná (UFPR), Departamento de Comunicación, Programa de Posgrado en Comunicación (PPGCOM-UFPR).',
          interest:
            'Mito; Consumo y Cultura Mediática; Arte, Mito y Medios de Comunicación; Mito, Consumo e Imaginario; Mito, Religión e Imaginario Cultural.'
        },
        alan: {
          institution: 'Universidad de Brasília - UnB',
          interest: 'Circularidades; Cultos Ancestrales; Culturas Amerindias y Afrodiásporicas.'
        },
        alvaro: {
          institution: 'Universidad de Antioquia - Facultad de Educación',
          interest: 'Educación; Educación popular; Diversidad epistémica; Narrativa.'
        }
      }
    }
  },
  seminar: {
    sectionOne: {
      title: 'Seminarios regulares',
      seeMore: 'Mira más en nuestro canal.',
      description:
        'Los seminarios se llevan a cabo regularmente a lo largo del año, cada primer sábado del mes a las 13:00 (hora de Brasilia), de forma remota. La agenda se construye conjuntamente al inicio de cada semestre. Todos los miembros de la Red pueden presentar sus trabajos de investigación y/o sugerir nombres de invitados. La invitación con el enlace se envía por correo electrónico y se realiza una difusión en nuestro Instagram. Los Seminarios regulares están abiertos al público.'
    },
    sectionTwo: {
      indicator: 'Videos 2023'
    },
    sectionThree: {
      indicator: 'Videos 2024'
    },
    seminar: 'Seminario',
    host: {
      male: 'Presentador',
      female: 'Presentadora',
    }
  },
  'become-member': {
    title: 'Forma parte de la <br /> Red Pachamama',
    description:
      'Si eres investigador, profesor, estudiante o artista interesado en discutir, colaborar y fortalecer los intercambios académicos en torno a la mitocrítica en América Latina, únete a nosotros. Recibirás por correo electrónico y/o WhatsApp toda la información sobre las actividades de la Red; podrás participar en los seminarios regulares como oyente y/o presentador; tendrás descuento en la inscripción a congresos internacionales y coloquios; podrás proponer colaboraciones, intercambios y otros convenios a los miembros de la Red y fortalecer su internacionalización en América Latina.',
    cards: {
      seminary: {
        title: 'Seminarios',
        summary: 'Seminarios mensuales en línea exclusivos para miembros de la Red Pachamama'
      },
      colloquia: {
        title: 'Coloquios',
        summary: 'Coloquios internacionales organizados por la Red Pachamama'
      },
      community: {
        title: 'Comunidad',
        summary: 'Comunidad integrada con el objetivo de compartir trabajos y conocimientos'
      },
      partnership: {
        title: 'Parcerias',
        summary: 'Parcerías con redes de otros países para una mayor difusión y más conexiones '
      }
    },
    becomeMemberButton: 'HACERSE MIEMBRO'
  },
  'who-we-are': {
    title: '¿Quiénes Somos?',
    card: {
      origin: {
        title: 'El Origen',
        info: `
          <p>
            <strong>La Red Latinoamericana de Mitocrítica Pachamama</strong> nació de un
            encuentro fortuito: en octubre de 2022, durante el Congreso
            Internacional de Mitocrítica convocado por la red Asteria, en la
            Universidad Complutense de Madrid, un grupo de investigadores
            provenientes de países latinoamericanos nos preguntamos por qué no
            había una red que se dedicara al estudio de los mitos de nuestros
            respectivos países desde la multidisciplinariedad.
          </p>

          <p>
            Ya desde esas pláticas coincidimos en que la riquísima tradición
            mítica que heredamos en América no solamente forma parte de nuestras
            historias nacionales sino que, en muchos sentidos, une a todo el
            continente bajo una historia compartida: <strong>la de nuestros antepasados indígenas</strong>,
            su cosmovisión, sus creencias y un abanico de tradiciones
            que muestran la vitalidad y la presencia constante de este pasado en
            el presente de América Latina. Por supuesto, los acontecimientos que
            han formado cada idiosincrasia, los diversos flujos migratorios y la
            historia particular de cada país, la manera de crear nuevos mitos y
            de sincretizar lo amerindio con la herencia europea, africana o
            asiática (no hay que olvidar la inmigración de grado o forzada de
            importantes grupos de Asia) brinda matices que hacen aún más
            compleja la producción cultural americana.
          </p>

          <p>
            Coincidimos, finalmente, en que el estudio de los mitos desde la
            Academia (con A mayúscula) suele limitarse en buena medida a la
            Antigüedad clásica (Grecia y Roma), la tradición hinduista, algunos
            relatos nórdicos y poco más:
            <strong>América prácticamente ha sido invisible para la mitocrítica y había que hacer algo al respecto.</strong>
          </p>
        `
      },
      network: {
        title: 'La Red',
        info: `
          <p>
            El <strong>4 de febrero de 2023</strong> nos reunimos nueve personas desde nuestro
            lugar de residencia, en estricto orden alfabético: Gabriel Caldas
            (Bogotá, Colombia), Luis Canting Placa (Bayamón, Puerto Rico),
            Miriam Carlos Silva (Sorocaba, Brasil), Florence Dravet
            (Brasilia, Brasil),Eduarda Filomeno Affonso (Braga, Portugal),
            Aleida Gelpí Acosta (Bayamón, Puerto Rico), Cristina Mondragón
            (Lausana, Suiza), Luis H. Pabón Batlle (Bayamón, Puerto Rico) y
            Luis Alberto Pérez Amezcua (Guadalajara, México) y decidimos formar
            la Red Latinoamericana de Mitocrítica. Pero necesitábamos un nombre,
            no solamente que nos identificara como grupo sino también que
            hiciera referencia a nuestra finalidad: el estudio de los mitos
            latinoamericanos antiguos y actuales. Alguien sugirió el nombre de
            <strong>Pachamama</strong> y así se quedó: había nacido el germen de nuestra red.
          </p>

          <p>
            Pocos días más tarde, gracias a las gestiones de Luis Pabón Batlle,
            la Universidad de Puerto Rico en Bayamón nos recibió como sede
            académica y con ello se oficializó el grupo de investigación bajo
            el nombre de <strong>Red Latinoamericana de Mitocrítica Pachamama</strong>
          </p>
        `
      },
      why: {
        title: '¿Por qué Pachamama?',
        info: `
          <p>
            <strong>Pachamama</strong> es la huaca (la manifestación sagrada) de la tierra en la
            religión de los quechua, la diosa que nos da la vida y nos recibe de
            vuelta con la muerte, madre del resto de las divinidades y del cosmos.
            Es una diosa telúrica, en tanto que sobre ella vivimos, de ella nos
            alimentamos nosotros y los animales no humanos con quienes convivimos,
            y es también ctónica pues alberga al inframundo, cuyas entradas
            (las cavernas) son albergue y tumba. Guarda el fuego de los volcanes,
            la fuerza de los terremotos y las fuentes de los ríos; representa la
            fertilidad, la creación y la naturaleza que cuida y mantiene. Como
            buena parte de las deidades antiguas, Pachamama también se identificó
            con la madre del dios de los invasores, María Virgen, otra figura
            poderosa que intercede entre los seres humanos y el Dios que heredamos
            de los europeos. Es, entonces, la Huaca de la tradición original
            amerindia, la Madre de Dios para la América cristianizada y el símbolo
            de la tierra, la vida y la muerte. ¿Qué mejor figura tutelar para
            nuestro grupo de mitólogos?
            <strong>La Pachamama representa esa parte del mito viva y funcional con la que vivimos todos los días en Latinoamérica.</strong>
          </p>
        `
      }
    }
  },
  magazines: {
    title: 'Revistas',
    magazines: {
      contemplator: 'Revista Universi <br /> Contemplator',
      esfera: 'Revista Esferas',
      amaltea: 'Revista Amaltea',
      accessButton: 'Aceder al Sitio',
    }
  },
  colloquies: {
    title: 'Coloquios',
    card: {
      title: 'VIII Congreso Internacional de Mitocrítica y I Coloquio Internacional de la Red Pachamama.',
      date: '29 a 31 de octubre de 2024',
      description: 'Con el fin de inaugurar el debate en torno a reflexiones comunes sobre el mito y la mitocrítica latinoamericana, Pachamama RLM y Asteria AIM se han unido en este VIII Congreso y I Coloquio, y convocan a investigadores interesados a enviar propuestas en torno a las siguientes líneas temáticas o temas afines:',
      list: [
        'Mito y cuestiones epistemológicas.',
        'Expresiones culturales del mito.',
        'El mito y sus alcances políticos.',
      ],
      button: 'Más información e inscripción',
    }
  },
  'in-construction': {
    title: 'PÁGINA EN CONSTRUCCIÓN.',
    description: 'Esta página aún no está disponible. Por favor, regrese en otro momento para encontrar nuestro contenido. Gracias por su comprensión.',
  }
};
